
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"30","height":"30"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"그룹 1247","transform":"translate(-9117 -5244)"}},[_c('circle',{attrs:{"data-name":"타원 169","cx":"15","cy":"15","r":"15","transform":"translate(9117 5244)","fill":"#fff"}}),_c('g',{attrs:{"data-name":"Icon feather-share-2","fill":"none","stroke":"#3c3c3c","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"2"}},[_c('path',{attrs:{"data-name":"패스 267","d":"M9137.6 5254.1a2.1 2.1 0 11-2.1-2.1 2.1 2.1 0 012.1 2.1z"}}),_c('path',{attrs:{"data-name":"패스 268","d":"M9129.2 5259a2.1 2.1 0 11-2.1-2.1 2.1 2.1 0 012.1 2.1z"}}),_c('path',{attrs:{"data-name":"패스 269","d":"M9137.6 5263.9a2.1 2.1 0 11-2.1-2.1 2.1 2.1 0 012.1 2.1z"}}),_c('path',{attrs:{"data-name":"패스 270","d":"M9128.913 5260.057l4.781 2.786"}}),_c('path',{attrs:{"data-name":"패스 271","d":"M9133.687 5255.157l-4.774 2.786"}})])])])
          )
        }
      }
    